import { render } from "./Fornecedor.vue?vue&type=template&id=7dddd110"
import script from "./Fornecedor.vue?vue&type=script&lang=js"
export * from "./Fornecedor.vue?vue&type=script&lang=js"

import "./Fornecedor.vue?vue&type=style&index=0&id=7dddd110&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__